// pages/ServicesPage.js
import React from 'react';
import './style.css';

function ServicesPage() {
  return (
    <div className="services-page">
      <div className="services-hero">
        <div className="container">
          <h1>Services</h1>
          <p>Innovative IT solutions to accelerate your digital transformation</p>
        </div>
      </div>

      <div className="container">
        <div className="services-intro">
          <h2>Technology expertise at your service</h2>
          <p>
            At TechSolutions Consulting, we offer a full range of IT services to support
            your company in its digital transformation. Our team of experts combines deep
            technical skills with strong industry experience to deliver solutions tailored to your needs.
          </p>
        </div>

        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-code"></i>
            </div>
            <h3>Custom Software Development</h3>
            <p>
              We build fully customized applications to meet your specific needs,
              from design to production.
            </p>
            <ul>
              <li>Web and mobile applications</li>
              <li>Enterprise software</li>
              <li>Systems integration</li>
              <li>Maintenance and enhancements</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-cloud"></i>
            </div>
            <h3>Cloud & Infrastructure</h3>
            <p>
              Optimize your IT infrastructure and migrate to the cloud for greater flexibility,
              performance, and security.
            </p>
            <ul>
              <li>Cloud migration (AWS, Azure, GCP)</li>
              <li>Cloud-native architecture</li>
              <li>Infrastructure as Code</li>
              <li>Cloud cost optimization</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h3>Cybersecurity</h3>
            <p>
              Protect your business from digital threats with our comprehensive security
              solutions tailored to your industry.
            </p>
            <ul>
              <li>Security audits</li>
              <li>Penetration testing</li>
              <li>Identity and access management</li>
              <li>Regulatory compliance (GDPR, etc.)</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-chart-bar"></i>
            </div>
            <h3>Data & Analytics</h3>
            <p>
              Leverage the value of your data to make informed decisions and
              develop new business models.
            </p>
            <ul>
              <li>Business Intelligence</li>
              <li>Big Data</li>
              <li>Machine Learning & AI</li>
              <li>Data governance</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-project-diagram"></i>
            </div>
            <h3>Digital Transformation</h3>
            <p>
              Strategic support to rethink your business processes and organization
              through digital technologies.
            </p>
            <ul>
              <li>Digital strategy consulting</li>
              <li>Change management</li>
              <li>Process automation</li>
              <li>Training and team enablement</li>
            </ul>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <i className="fas fa-users-cog"></i>
            </div>
            <h3>Staffing & Team Extension</h3>
            <p>
              Strengthen your teams with our IT talent to accelerate your projects and fill
              skill gaps.
            </p>
            <ul>
              <li>IT recruitment</li>
              <li>Dedicated teams</li>
              <li>Contract developers</li>
              <li>CTO as a Service</li>
            </ul>
          </div>
        </div>

        <div className="methodology-section">
          <h2>Our methodology</h2>
          <div className="methodology-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Analysis & Design</h3>
              <p>In-depth understanding of your challenges & design of a solution aligned with your objectives</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Implementation</h3>
              <p>Development and deployment of the solution using agile methodology</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Maintenance & Continuous Improvement</h3>
              <p>Ongoing support and iterative enhancement of the solution</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesPage;